export default "__VITE_ASSET__DcRBjhe5__"